import { OpenInNew } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { startCase, truncate } from 'lodash';
import { useState } from 'react';
import RouterLinkNoUnderline from 'src/components/common/RouterLinkNoUnderline';
import CustomTable from 'src/components/Table';
import { useQueryCompanyExactNegativeMedia } from 'src/services/queries';
import { FORMAT_DATE_TIME, LIMIT_GET_LIST } from 'src/utils/constants/config';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { formatUTCTime } from 'src/utils/helpers/dayjs';
import { formatUrlNonProtocol, getStringOrDefault, renderTextOrDefault } from 'src/utils/helpers/stringHelpers';

const NegativeMediaTable = ({ id = '' }: { id?: string | null }) => {
  const [paramsExact, setParamsExact] = useState({
    limit: LIMIT_GET_LIST,
    offset: 0,
  });

  const { isFetching: isFetchingExact, data: dataExact } = useQueryCompanyExactNegativeMedia({
    id: getStringOrDefault(id),
    params: paramsExact,
  });

  const listNegativeExact = getArrayDefault(dataExact?.data);

  return (
    <CustomTable
      maxRow={5}
      onChangePage={(e) => setParamsExact({ ...paramsExact, ...{ offset: e } })}
      onChangePageSize={(e) => setParamsExact({ ...paramsExact, ...{ offset: 0, limit: e } })}
      page={paramsExact.offset}
      pageSize={paramsExact.limit}
      loading={isFetchingExact}
      data={listNegativeExact}
      totalRecords={dataExact?.total_pages ? dataExact?.total_pages * paramsExact.limit : 0}
      configColumn={[
        {
          id: 'title',
          disablePadding: true,
          label: 'Title',
          cell: (row: INegativeMedia) => {
            return (
              <Typography color={'text.secondary'} variant="body2">
                {renderTextOrDefault(row.title)}
              </Typography>
            );
          },
        },
        {
          id: 'outlet',
          disablePadding: false,
          label: 'Outlet',
          width: 150,
          cell: (row: INegativeMedia) => {
            return (
              <Typography variant="body2" color="text.secondary">
                {renderTextOrDefault(startCase(row.site))}
              </Typography>
            );
          },
        },
        {
          id: 'date',
          disablePadding: false,
          width: 200,
          label: 'Date Retrieved',
          cell: (row: INegativeMedia) => {
            return (
              <Typography variant="body2" color="text.secondary">
                {formatUTCTime(FORMAT_DATE_TIME.FULL_ONLY_DATE, row.extracted_at)}
              </Typography>
            );
          },
        },
        {
          id: 'url',
          disablePadding: false,
          label: 'Source Link (URL)',
          cell: (row: INegativeMedia) => {
            return (
              <RouterLinkNoUnderline to={formatUrlNonProtocol(row.url || '')} target="_blank">
                <Typography ml={1} variant="body2" color="secondary.main">
                  {truncate(`${renderTextOrDefault(row.url)}`, {
                    length: 50,
                  })}
                </Typography>
                <OpenInNew fontSize="small" color="secondary" />
              </RouterLinkNoUnderline>
            );
          },
        },
      ]}
      dataKey="id"
    />
  );
};

export default NegativeMediaTable;
